import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import Header from "../../components/Header";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { SupportService } from "../../api/support.service";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";
import SupportOverview from "./SupportOverview";
import SupportFeedback from "./SupportFeedback";
import SupportHistory from "./SupportHistory";
import { useTranslation } from "react-i18next";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function tabProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SupportView = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { id } = useParams();
  const [support, setSupport] = useState();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!id) return;
    const fetchSupportData = async (id) => {
      const data = await SupportService.getById(id);
      setSupport(data);
    };

    fetchSupportData(id);
  }, [id]);

  if (!support) return;

  return (
    <Box m="20px">
      <Header title={t("VIEW Support")} subtitle={t("View Support")} />

      <Box sx={{ flex: 1 }} mt="40px">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{ background: colors.blueAccent[600] }}
            indicatorColor="secondary"
            textColor="secondary"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
          >
            <Tab
              label={t("Overview")}
              {...tabProps(0)}
              sx={{
                "& .Mui-selected": {
                  color: `${colors.redAccent[700]} !important`,
                },
              }}
            />
            <Tab label={t("Send Feedback")} {...tabProps(1)} />
            <Tab label={t("History")} {...tabProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <SupportOverview />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <SupportFeedback />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <SupportHistory />
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

export default SupportView;
